import UserService from '../../services/user';

// initial state
const state = {
	isLoggedIn: false,
	isConfirmed: false,
	status: '',
	plan: {
		name: '',
		trialDays: 0
	},
	profile: {
		email: null
	},
	isScreenMonitoringEnabled: false,
	numberOfNewNotifications: 0,
	isLoadingNotifications: false,
	notifications: []
};

// getters
const getters = {
	profile: state => state
};

// actions
const actions = {
	updateNumberOfNewNotifications({ commit }) {
		UserService.getNumberOfNewNotifications().then(response => {
			commit('UPDATE_NUM_OF_NEW_NOTIFICATIONS', response.data.news);
		}).catch(() => {
			commit('UPDATE_NUM_OF_NEW_NOTIFICATIONS', 0);
		});
	},
	getNotifications({ commit }) {
		commit('SET_IS_LOADING_NOTIFICATIONS', true);
		UserService.getLastestNotifications().then(response => {
			commit('UPDATE_NOTIFICATION', response.data.news);
		}).catch(() => {
			commit('SET_IS_LOADING_NOTIFICATIONS', false);
		});
	}
};

// mutations
const mutations = {
	'LOGIN_USER'(state, payload) {
		state.isLoggedIn = true;
		state.profile = {
			email: payload.email
		};
	},
	'LOGOUT_USER'(state) {
		state.isLoggedIn = false;
		state.isConfirmed = false;
		state.profile = {
			email: null
		};
		state.status = '';
		state.plan = {
			name: '',
			trialDays: 0
		};
		state.isScreenMonitoringEnabled = false;
		state.numberOfNewNotifications = 0;
		state.isLoadingNotifications = false;
		state.notifications = [];
	},
	'CONFIRM_USER'(state) {
		state.isConfirmed = true;
	},
	'UPDATE_SUB_INFO'(state, payload) {
		state.status = payload.status.toLowerCase();
		state.plan.name = payload.plan.name;
		state.plan.trialDays = payload.plan.trialDays;
	},
	'UPDATE_SCREEN_MONITORING'(state, payload) {
		state.isScreenMonitoringEnabled = payload;
	},
	'UPDATE_NUM_OF_NEW_NOTIFICATIONS'(state, payload) {
		state.numberOfNewNotifications = payload;
	},
	'SET_IS_LOADING_NOTIFICATIONS'(state, payload) {
		state.isLoadingNotifications = payload;
	},
	'UPDATE_NOTIFICATION'(state, payload) {
		const exp = /(\b(https?|ftp|file):\/\/[-A-Z0-9+&@#\/%?=~_|!:,.;]*[-A-Z0-9+&@#\/%=~_|])/ig;
		state.notifications = payload;
		state.notifications.forEach(notification => {
			notification.content = notification.content.replace(exp, '<a class="notifications__link" target="_blank" href="$1">$1</a>')
		});
		state.numberOfNewNotifications = 0;
		state.isLoadingNotifications = false;
	}
};
export default {
	state,
	getters,
	actions,
	mutations
};



// WEBPACK FOOTER //
// ./app/store/modules/user.js